import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './BannerCarousel.css'


const settings = {
  fade: true,
  infinite: true,
  speed: 1000,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
};

const BannerCarousel = ({ images,className }) => (
    <Slider {...settings}>
      {images.map((image, index) => (
        <div className="" key={index}>
          <img className={`w-full mx-auto ${className}`} src={image} alt={`Banner ${index + 1}`} />
        </div>
      ))}
    </Slider>
);

export default BannerCarousel;
